export const MenuConstants = {
    MENU_TOGGLE: 'MENU_TOGGLE',

    SET_CONTENT_MENU: 'SET_CONTENT_MENU',

    SET_TITLE: 'SET_TITLE',
};